<template>
  <v-menu offset-y v-model="menu" :nudge-width="200" :close-on-click="false" :close-on-content-click="false">
    <template #activator="{on}">
      <slot name="activator" :on="on" :selected="selected" :selected-name="selectedName">
        <v-btn color="primary" dark slot="activator" v-on="on">{{btnText}}</v-btn>
      </slot>
    </template>
    <v-card class="white">
      <v-card-title primary-title>
        {{title}}
      </v-card-title>
    </v-card>
    <structure-navigation v-model="selected">
      <!-- <template #node="{node,data}">
        {{data.Cd}} {{data.Name}}
      </template> -->
    </structure-navigation>
    <v-card-actions style="background: white">
      <v-spacer></v-spacer>
      <v-btn flat @click="menu = false">取消</v-btn>
      <v-btn color="primary" flat @click="submit()" v-show="selected">确认</v-btn>
    </v-card-actions>

  </v-menu>
</template>

<style scoped>

</style>

<script>
  import StructureSelector from "./structureSelector.ts";
  export default StructureSelector;
</script>